import { render } from "./hospedaje2.vue?vue&type=template&id=7384a6a0&scoped=true"
import script from "./hospedaje2.vue?vue&type=script&lang=js"
export * from "./hospedaje2.vue?vue&type=script&lang=js"

import "./hospedaje2.vue?vue&type=style&index=0&id=7384a6a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7384a6a0"]])

export default __exports__